<template>
  <div class="board-box">
    <a-row :gutter="10">
      <a-col :span="8" class="text-subtitle">
        <div class="board-top-label mb-1">
          <p class="text-title">销售线索</p>
        </div>
        <div class="card sales-leads-box mb-1">
          <div class="sales-leads-item" style="padding-bottom: 0; border-right: 1px solid #dde3ee">
            <p>线索总数量</p>
            <span>{{ formatThousandSeparator(clueDashboard.clueTotal) }}</span>
          </div>
          <div class="sales-leads-item" style="padding-bottom: 0">
            <p>待跟进线索数</p>
            <span>{{ formatThousandSeparator(clueDashboard.clueFollowingUp) }}</span>
          </div>
          <div
            class="sales-leads-item"
            style="padding-bottom: 0; border-top: 1px solid #dde3ee; border-right: 1px solid #dde3ee"
          >
            <p>线索跟进及时率</p>
            <span>{{ clueDashboard.clueFollowingUpRate }}</span>
          </div>
          <div class="sales-leads-item" style="padding-bottom: 0; border-top: 1px solid #dde3ee">
            <p>线索转化率</p>
            <span>{{ clueDashboard.clueConvertedRate }}</span>
          </div>
        </div>

        <div class="card mb-1" style="padding: 12px 0">
          <div class="board-top-label mx-12">
            <p class="text-subtitle">线索分布情况</p>
            <a-select
              v-model:value="clueTypeValue"
              class="from-box mr-12"
              style="width: 100px"
              @change="fetchClueTypeList"
            >
              <a-select-option value="0">类型</a-select-option>
              <a-select-option value="1">来源</a-select-option>
              <a-select-option value="2">状态</a-select-option>
            </a-select>
          </div>
          <BoardPieChart
            height="230px"
            :data="
              clueTypeValue === '0'
                ? clueDashboard.clueTypeListChartData
                : clueTypeValue === '1'
                ? clueDashboard.clueChannelListChartData
                : clueDashboard.clueStateListChartData
            "
          />
        </div>
        <div class="card board-padding">
          <div class="board-top-label">
            <p class="text-subtitle">线索跟进及时率</p>
            <div class="from-box">
              <a-date-picker
                v-model:value="followingValue"
                v-if="followingUpRateListParam.dateQueryType === 3"
                :allowClear="false"
                @change="fetchFollowing"
                picker="year"
              />
              <a-date-picker
                v-model:value="followingValue"
                v-if="followingUpRateListParam.dateQueryType === 1"
                :allowClear="false"
                @change="fetchFollowing"
                picker="month"
              />

              <a-radio-group
                v-model:value="followingUpRateListParam.dateQueryType"
                style="margin-left: 20px"
                @change="fetchFollowing"
              >
                <a-radio-button :value="1">天</a-radio-button>
                <a-radio-button :value="3">月</a-radio-button>
              </a-radio-group>
            </div>
          </div>
          <BoardLineChart height="230px" :data="followingUpRateList" :isPercentageY="true" />
        </div>
      </a-col>
      <a-col :span="16" class="text-subtitle">
        <div class="board-top-label mb-1">
          <p class="text-title">商机</p>
        </div>
        <div class="grid-3 mb-1 text-white">
          <div class="sales-leads-item rounded bg1">
            <p>商机总数量</p>
            <span style="color: #fff">{{ formatThousandSeparator(chanceDashboard.chanceTotal) }}</span>
          </div>
          <div class="sales-leads-item rounded bg2">
            <p>预计月销售额(万元)</p>
            <span style="color: #fff">{{ formatThousandSeparator(chanceDashboard.planSaleAmountTotal) }}</span>
          </div>
          <div class="sales-leads-item rounded bg3">
            <p>实际月销售额(万元)</p>
            <span style="color: #fff">{{ formatThousandSeparator(chanceDashboard.monthActualSaleAmountTotal) }}</span>
          </div>
        </div>
        <div class="grid-3 mb-1">
          <div class="card">
            <BoardGaugeChart height="230px" :data="chanceDashboard.chanceConvertedRateChartData" />
          </div>
          <div class="card">
            <BoardGaugeChart height="230px" :data="chanceDashboard.saleAmountRateChartData" />
          </div>
          <div class="card">
            <BoardGaugeChart height="230px" :data="chanceDashboard.chanceSuccessRateRateChartData" />
          </div>
        </div>
        <div class="grid-2">
          <div class="card">
            <p class="mx-12 mb-1 pt-12">商机状态分布情况</p>
            <BoardFunnelChart height="350px" :data="chanceDashboard.chanceStatusListChartData" />
          </div>
          <div class="card">
            <div class="board-top-label mx-12 pt-12">
              <!-- <p>商机新增情况</p> -->
              <a-radio-group v-model:value="chanceTypeValue" @change="fetchIncList">
                <a-radio-button :value="0">商机新增情况</a-radio-button>
                <a-radio-button :value="1">商机转化情况</a-radio-button>
              </a-radio-group>
              <div class="from-box">
                <a-date-picker
                  v-model:value="selectValue"
                  :allowClear="false"
                  v-if="chanceIncListParam.dateQueryType === 3"
                  @change="fetchIncList"
                  picker="year"
                />
                <a-range-picker
                  v-model:value="weakValues"
                  :allowClear="false"
                  v-if="chanceIncListParam.dateQueryType === 2"
                  picker="week"
                  style="width: 220px"
                  @change="fetchIncList"
                />

                <a-radio-group
                  v-model:value="chanceIncListParam.dateQueryType"
                  style="margin-left: 20px"
                  @change="fetchIncList"
                >
                  <a-radio-button :value="2">周</a-radio-button>
                  <a-radio-button :value="3">月</a-radio-button>
                </a-radio-group>
              </div>
            </div>
            <BoardLineChart height="360px" :data="chanceIncList" :isPercentageY="chanceTypeValue === 1" />
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, toRef, watch, PropType } from 'vue'
import BoardPieChart from './componects/BoardPieChart.vue'
import BoardLineChart from './componects/BoardLineChart.vue'
import BoardFunnelChart from './componects/BoardFunnelChart.vue'
import BoardGaugeChart from './componects/BoardGaugeChart.vue'
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import formatThousandSeparator from '@/utils/format'
import dayjs, { Dayjs } from 'dayjs'

const props = defineProps({
  formState: {
    type: Object as PropType<Object>
  }
})

const clueDashboard = ref({
  clueTotal: 0,
  clueFollowingUp: 0,
  clueFollowingUpRate: '0%',
  clueConvertedRate: '0%'
})

const chanceDashboard = ref({
  chanceTotal: 0,
  planSaleAmountTotal: 0,
  monthActualSaleAmountTotal: 0
})
const followingUpRateList = ref([])
const chanceIncList = ref([])

const clueTypeValue = ref('1')
const chanceTypeValue = ref<number>(0)
const followingValue = ref<Dayjs>(dayjs())
const selectValue = ref<Dayjs>(dayjs())
const weakValues = ref<[Dayjs, Dayjs]>([dayjs().startOf('week').add(-13, 'week'), dayjs().startOf('week')])

const formState = toRef(props, 'formState')

watch(
  () => props.formState,
  (newValue) => {
    formState.value = newValue
    fetchData()
  }
)

const followingUpRateListParam = ref({
  dateQueryType: 1
})

const chanceIncListParam = ref({
  dateQueryType: 3
})

const fetchClueTypeList = () => {
  request.post<AxiosResult, AxiosResult>('/fbu/api/report/clue/dashboard', formState.value).then((res) => {
    clueDashboard.value = res.data
    clueDashboard.value.clueTypeListChartData = (res.data?.clueTypeList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })
    clueDashboard.value.clueChannelListChartData = (res.data?.clueChannelList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })

    clueDashboard.value.clueStateListChartData = [
      { name: '跟进中', value: res.data?.clueFollowingUp || 0 },
      { name: '已转化', value: res.data?.clueConverted || 0 }
    ]
  })
}
const fetchData = () => {
  fetchClueTypeList()

  fetchFollowing()

  request.post<AxiosResult, AxiosResult>('/fbu/api/report/chance/dashboard', formState.value).then((res) => {
    chanceDashboard.value = res.data
    chanceDashboard.value.chanceConvertedRateChartData = [
      {
        name: '转化率',
        itemStyle: { color: '#12AEA5' },
        value: convertPercentageToNumber(res.data.chanceConvertedRate),
        tooltip: `已转化商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceConverted}</span><br>总商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceTotal}</span><br>转化率 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceConvertedRate}</span><p style="color:#FF9A3E;" >注:不统计当前月及前3个月数据</p>`
      }
    ]
    chanceDashboard.value.saleAmountRateChartData = [
      {
        name: '销售额达成率',
        itemStyle: { color: '#1D4CD2' },
        value: convertPercentageToNumber(res.data.saleAmountRate),
        // value: 462564797.71,
        tooltip: `实际月销售额 <span style="font-weight: bolder;font-size: 16px">${res.data.monthActualSaleAmountTotal}</span><br>预计月销售额 <span style="font-weight: bolder;font-size: 16px">${res.data.planSaleAmountTotal}</span><br>达成率 <span style="font-weight: bolder;font-size: 16px">${res.data.saleAmountRate}</span><p style="color:#FF9A3E;" >注:不统计当前月及前3个月数据</p>`
      }
    ]
    chanceDashboard.value.chanceSuccessRateRateChartData = [
      {
        name: '完结率',
        itemStyle: { color: '#ff9a3e' },
        value: convertPercentageToNumber(res.data.chanceSuccessRate),
        // value: 70,
        tooltip: `已完结商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceSuccess}</span><br>总商机数 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceTotal}</span><br>完结率 <span style="font-weight: bolder;font-size: 16px">${res.data.chanceSuccessRate}</span><p style="color:#FF9A3E;" >注:不统计当前月及前3个月数据</p>`
      }
    ]
    chanceDashboard.value.chanceTypeListChartData = (res.data?.chanceTypeList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })
    chanceDashboard.value.orderTypeListChartData = (res.data?.orderTypeList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })

    chanceDashboard.value.chanceStatusListChartData = (res.data?.chanceStatusList || []).map((item) => {
      return { name: item.name, value: item.quantity }
    })
  })

  fetchIncList()
}

const fetchFollowing = () => {
  if (chanceIncListParam.value.dateQueryType === 3) {
    followingUpRateListParam.value.startMonth = dayjs(followingValue.value).startOf('month').format('YYYY01')
    followingUpRateListParam.value.endMonth = dayjs(followingValue.value).endOf('month').format('YYYY12')
  } else if (chanceIncListParam.value.dateQueryType === 1) {
    followingUpRateListParam.value.startDay = dayjs(followingValue.value).startOf('month').format('YYYY/MM/DD')
    followingUpRateListParam.value.endDay = dayjs(followingValue.value).endOf('month').format('YYYY/MM/DD')
  }

  request
    .post<AxiosResult, AxiosResult>('/fbu/api/report/clue/followingUpRateList', {
      ...formState.value,
      ...followingUpRateListParam.value
    })
    .then((res) => {
      followingUpRateList.value = generateClueFollowingUpRateList(res.data?.clueFollowingUpRateList || [])
    })
}

const generateClueFollowingUpRateList = (clueFollowingUpRateList: any) => {
  if (followingUpRateListParam.value.dateQueryType === 3) {
    const datas = []
    const year = dayjs(followingValue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = clueFollowingUpRateList.find((ii: any) => ii.monthValue % 100 === i)
      const quantity = item?.quantity || 0
      const total = item?.total || 0
      const rate = (total > 0 ? quantity / total : 0).toFixed(4)
      datas.push({
        name: `${i}`,
        value: rate,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>及时客户 <span style="font-weight: bolder;font-size: 16px">${quantity}</span><br>总客户 <span style="font-weight: bolder;font-size: 16px">${total}</span><br>及时率 <span style="font-weight: bolder;font-size: 16px">${(
          rate * 100
        ).toFixed(2)}%</span>`
      })
    }
    return datas
  } else {
    let currentDay = dayjs(followingValue.value).startOf('month')
    const lastDay = dayjs(followingValue.value).endOf('month')
    const calendarArray = []

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = clueFollowingUpRateList.find((i) => i.dayValue === currentDay.format('YYYY/MM/DD'))
      const quantity = item?.quantity || 0
      const total = item?.total || 0
      const rate = (total > 0 ? quantity / total : 0).toFixed(4)
      calendarArray.push({
        name: currentDay.format('D'),
        value: rate,
        tooltip: `${currentDay.format(
          'YYYY/MM/DD'
        )}<br>及时客户 <span style="font-weight: bolder;font-size: 16px">${quantity}</span><br>总客户 <span style="font-weight: bolder;font-size: 16px">${total}</span><br>及时率 <span style="font-weight: bolder;font-size: 16px">${(
          rate * 100
        ).toFixed(2)}%</span>`
      })
      currentDay = currentDay.add(1, 'day')
    }
    return calendarArray
  }
}

const fetchIncList = () => {
  if (chanceIncListParam.value.dateQueryType === 3) {
    chanceIncListParam.value.startMonth = dayjs(selectValue.value).startOf('month').format('YYYY01')
    chanceIncListParam.value.endMonth = dayjs(selectValue.value).endOf('month').format('YYYY12')
  } else if (chanceIncListParam.value.dateQueryType === 2) {
    chanceIncListParam.value.startWeek = dayjs(weakValues.value[0]).format('YYYYww')
    chanceIncListParam.value.endWeek = dayjs(weakValues.value[1]).format('YYYYww')
  }

  if (chanceTypeValue.value === 0) {
    request
      .post<AxiosResult, AxiosResult>('/fbu/api/report/chance/incList', {
        ...formState.value,
        ...chanceIncListParam.value
      })
      .then((res) => {
        chanceIncList.value = generateIncList(res.data.chanceIncList || [])
      })
  } else {
    request
      .post<AxiosResult, AxiosResult>('/fbu/api/report/chance/convertedList', {
        ...formState.value,
        ...chanceIncListParam.value
      })
      .then((res) => {
        chanceIncList.value = generateChanceConvertedList(res.data?.chanceConvertedList || [])
      })
  }
}

const generateChanceConvertedList = (list: any) => {
  const datas = []

  if (chanceIncListParam.value.dateQueryType === 3) {
    const year = dayjs(selectValue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const quantity = item?.quantity || 0
      const total = item?.total || 0
      const rate = (total > 0 ? quantity / total : 0).toFixed(4)
      datas.push({
        name: `${i}`,
        value: rate,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>转化商机 <span style="font-weight: bolder;font-size: 16px">${quantity}</span><br>总商机 <span style="font-weight: bolder;font-size: 16px">${total}</span><br>转化率 <span style="font-weight: bolder;font-size: 16px">${(
          rate * 100
        ).toFixed(2)}%</span>`
      })
    }
  } else {
    let currentDay = dayjs(weakValues.value[0])
    const lastDay = dayjs(weakValues.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      const quantity = item?.quantity || 0
      const total = item?.total || 0
      const rate = total > 0 ? quantity / total : 0
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: rate,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format(
            'YYYY/MM/DD'
          )}<br>转化商机 <span style="font-weight: bolder;font-size: 16px">${quantity}</span><br>总商机 <span style="font-weight: bolder;font-size: 16px">${total}</span><br>转化率 <span style="font-weight: bolder;font-size: 16px">${(
          rate * 100
        ).toFixed(2)}%</span>`
      })
      currentDay = currentDay.add(1, 'week')
    }
  }

  return datas
}

const generateIncList = (list: any) => {
  const datas = []

  if (chanceIncListParam.value.dateQueryType === 3) {
    const year = dayjs(selectValue.value).startOf('month').format('YYYY')
    for (let i = 1; i <= 12; i++) {
      const item = list.find((ii: any) => ii.monthValue % 100 === i)
      const quantity = item?.quantity || 0
      datas.push({
        name: `${i}`,
        value: quantity,
        tooltip: `${year}/${String(i).padStart(
          2,
          '0'
        )}<br>新商机数 <span style="font-weight: bolder;font-size: 16px">${quantity}</span>`
      })
    }
  } else {
    let currentDay = dayjs(weakValues.value[0])
    const lastDay = dayjs(weakValues.value[1])

    while (currentDay.isBefore(lastDay.endOf('day')) || currentDay.isSame(lastDay.endOf('day'), 'day')) {
      // console.log('YYYY:', parseInt(currentDay.format('YYYYww'))
      const item = list.find((ii: any) => ii.weekValue === parseInt(currentDay.format('YYYYww')))
      const quantity = item?.quantity || 0
      datas.push({
        name: currentDay.format('YYYY-wo'),
        value: quantity,
        tooltip: `${currentDay.startOf('week').format('YYYY/MM/DD')}-${currentDay
          .endOf('week')
          .format('YYYY/MM/DD')}<br>新商机数 <span style="font-weight: bolder;font-size: 16px">${quantity}</span>`
      })
      currentDay = currentDay.add(1, 'week')
    }
  }

  return datas
}

function convertPercentageToNumber(percentageString: string): number {
  const noPercentage = percentageString.replace(/%/, '').replaceAll(',', '')
  return Number(noPercentage)
}

onMounted(() => {
  fetchData()
})
</script>

<script lang="ts">
export default { name: 'DcCosFbuDataBoard' }
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>